module.exports = __webpack_public_path__ + "assets/infobox_icon.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/infobox_icon.svg
// module id = 783
// module chunks = 0